import axios from 'axios';
import store from "../redux/store";
const axiosInstance = axios.create({
  baseURL: "https://billingdevapi.pbhbillingportal.com/",
  // baseURL: "http://127.0.0.1:8000/", // local only — do not commit
  // withCredentials: true,
  // headers: {
  //   'Access-Control-Allow-Credentials': 'true',
  //   'Access-Control-Allow-Origin': 'https://localhost:3000',
  //   'Access-Control-Allow-Methods': 'GET, DELETE, PATCH, POST, PUT',
  //   'Access-Control-Allow-Headers': 'Content-Type, Authorization',
  // },
});

axiosInstance.interceptors.request.use((config) => {
  const state = store.getState();
  const token = state.user?.accessToken;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
})

// const setAuthorizationToken = () => {
//   const token = localStorage.getItem('accessToken');

//   if (token) {
//     axiosInstance.defaults.headers.Authorization = `Bearer ${token}`;
//   } else {
//     axiosInstance.defaults.headers.Authorization = '';
//   }
// };

const executeRequest = (method, endPoint, body, successCallback, errorCallback) => {
  // setAuthorizationToken();

  const config = {
    method,
    url: endPoint,
    data: body,
    params: method === 'GET' || method === 'DELETE' ? body : null,
  };

  axiosInstance(config)
    .then((response) => {
      successCallback(response);
    })
    .catch((error) => {
      errorCallback(error);
    });
};

const getAPI = (endPoint, body, successCallback, errorCallback) => {
  executeRequest('GET', endPoint, body, successCallback, errorCallback);
};

const postAPI = (endPoint, body, successCallback, errorCallback) => {
  executeRequest('POST', endPoint, body, successCallback, errorCallback);
};

const putAPI = (endPoint, body, successCallback, errorCallback) => {
  executeRequest('PUT', endPoint, body, successCallback, errorCallback);
};

const patchAPI = (endPoint, body, successCallback, errorCallback) => {
  executeRequest('PATCH', endPoint, body, successCallback, errorCallback);
};

const deleteAPI = (endPoint, body, successCallback, errorCallback) => {
  executeRequest('DELETE', endPoint, body, successCallback, errorCallback);
};

export { axiosInstance, getAPI, postAPI, putAPI, patchAPI, deleteAPI };
